<template>
  <div
    class="container fullscreen-layout"
    :style="bgStyle"
  >
    <div
      class="system-info"
      :class="{'is-notify':isNotify}"
      v-if="info.identifyType === '0'"
    >
      <img
        class="logo"
        :src="logoPath"
        v-if="info.loginLogoInfo"
        :style="iconImgStyle"
      >
      <span
        class="title"
        :style="systemNameStyle"
      >{{info.systemName}}</span>
      <span
        class="sub-title"
        :style="systemNameStyle"
      >{{info.systemSubtitle}}</span>
    </div>
    <div  class="system-info" v-else>
      <img
        class="logo"
        :src="info.identifyImgInfo.path"
        :style="identifyImgInfoStyle"
      >
    </div>
    <div
      class="m-main-content"
      :style="imageStyle"
      v-if="info.cImgType==='0'"
    >
      <div class="form-wrapper">
        <slot></slot>
      </div>
    </div>
    <div
      class="m-main-content"
      v-else
    >
      <lottie
        :options="defaultOptions"
        :dateTime="dateTime"
      ></lottie>
      <div class="form-wrapper">
        <slot></slot>
      </div>
    </div>
    <div
      class="select-wrapper"
      :class="{'is-notify':isNotify}"
    >
      <el-button
        type="iconButton"
        icon="h-icon-download"
        class="down-btn"
        :style="downloadTextColor"
        @click="openDownLoad"
      >
        {{$t('login.download_text')}}
      </el-button>
      <slot
        name="lang-select"
      ></slot>
    </div>
    <div class="version-info-wrapper">
      <version-info></version-info>
    </div>
  </div>
</template>

<script>
import versionInfo from './version-info.vue'
import lottie from 'components/lottie/lottie'
import axios from 'axios'
export default {
  name: 'fullscreen-layout',
  props: {
    info: {
      type: Object,
      default: () => {
        return {
          backgroundImgInfo: {
            path: ''
          },
          bgColor: '',
          bgImgType: '1',
          cImgType: '0',
          ctImgInfo: {
            path: ''
          },
          ctZipInfo: {
            path: ''
          },
          identifyImgInfo:{
            path: ''
          },
          identifyType:'0',
        }
      }
    },
    isNotify: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      defaultOptions: {},
      dateTime: new Date().getTime()
    }
  },
  computed: {
    downloadTextColor () {
      return {
        'color': `${this.info.downloadTextColor || '#4d4d4d'}`
      }
    },
    bgStyle () {
      let _res = {}
      if (this.info.bgImgType === '0') {
        _res['background-image'] = `url(${this.info.backgroundImgInfo.path})`
        _res['background-size'] = 'cover'
      } else {
        _res['background-color'] = this.info.bgColor
      }
      if(!this.info.recordNumber){
        _res['height'] = '100%'
      }
      return _res
    },
    systemNameStyle () {
      return {
        'color': `${this.info.systemNameColor || '#fff'}`
      }
    },
    imageStyle () {
      return {
        'background-image': `url(${this.info.ctImgInfo.path})`
      }
    },
    iconImgStyle () {
      const _iconImg = this.info.loginLogoInfo
      if (!_iconImg) return {}
      const _height = parseInt(_iconImg.height) < 38 ? _iconImg.height : 38
      return {
        height: `${_height}px`
      }
    },
    identifyImgInfoStyle(){
      const _identifyImgInfo = this.info.identifyImgInfo.path
      if (!_identifyImgInfo) return {}
      const _height = parseInt(_identifyImgInfo.height) < 61 ? _identifyImgInfo.height : 60
      return {
        height: `${_height}px`
      }
    },
    logoPath () {
      return this.info.loginLogoInfo ? this.info.loginLogoInfo.path : ''
    },
  },
  methods: {
    openDownLoad () {
      this.$emit('open-download')
    },
    async getAnimatJson () {
      if (this.info.ctZipId !== '-1' && this.info.cImgType) {
        const requestUrl = this.info.ctZipInfo.path
        const animatJson = await axios.get(requestUrl)
        for (let i = 0; i < animatJson.data.assets.length; i++) {
          if (animatJson.data.assets[i].u) {
            animatJson.data.assets[i].u = `${process.env.VUE_APP_BASEURL}/zip/dynamicDisplay/${this.info.ctZipId}/images/`
          } else {
            break
          }
        }
        this.dateTime = new Date().getTime()
        this.defaultOptions = { animationData: animatJson.data }
      }
    }
  },
  components: {
    versionInfo,
    lottie
  },
  watch: {
    info: {
      handler () {
        this.getAnimatJson()
      },
      deep: true
    }
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.fullscreen-layout.container {
  width: 100%;
  height: calc(~"100% - 30px");
  position: relative;
  background-size: cover;
  .system-info {
    height: 38px;
    position: absolute;
    left: 32px;
    top: 24px;
    z-index: 9;
    .title {
      display: block;
      position: absolute;
      top: 0;
      left: 46px;
      font-size: 22px;
      line-height: 22px;
      font-weight: bold;
      height: 22px;
      color: #fff;
      white-space: pre;
    }
    .sub-title {
      display: block;
      position: absolute;
      bottom: 0px;
      left: 46px;
      font-size: 12px;
      line-height: 14px;
      height: 14px;
      color: #fff;
      white-space: pre;
    }
    .logo {
      display: inline-block;
      vertical-align: middle;
      width: auto;
    }
  }
  .system-info.is-notify {
    top: 56px;
  }
  .copyright-wrapper {
    position: absolute;
    bottom: 24px;
    left: 50%;
    transform: translateX(-50%);
    height: 16px;
    .name {
      text-decoration: none;
      display: inline-block;
      vertical-align: middle;
    }
    .logo {
      display: inline-block;
      vertical-align: middle;
    }
  }
  .content-wrapper {
    position: absolute;
    width: 1200px;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    font-size: 0;
    .bgimg-wrapper {
      width: 792px;
      height: 630px;
      display: inline-block;
      margin-right: 80px;
      vertical-align: middle;
      .inner {
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
      }
    }
    .form-wrapper {
      width: 400px;
      // padding-bottom: 20px;
      display: inline-block;
      vertical-align: middle;
      margin-bottom: 34px;
    }
  }
  .select-wrapper {
    position: absolute;
    top: 24px;
    right: 32px;
    display:flex;
    align-content: center;
    .down-btn {
      vertical-align: middle;
      font-weight: normal;
      background: none;
      opacity: 0.6;
      border: 1px solid rgba(255,255,255,0.12);
      border-radius: 2px;
      filter: alpha(opacity=60);
      &:hover {
        background: none;
        opacity: 1;
        filter: alpha(opacity=100);
      }
    }
  }
  .select-wrapper.is-notify {
    top: 56px;
  }
  .version-info-wrapper {
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .m-main-content {
    position: relative;
    width: 60%;
    height: 90%;
    top: 7%;
    // background-image: url("../../assets/images/fff.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center right;
    .form-wrapper {
      position: absolute;
      right: -448px;
      width: 400px;
      top: 50%;
      border-radius: 3px;
      margin-top: -200px;
      display: inline-block;
      vertical-align: middle;
      margin-bottom: 34px;
      background: #fff;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.08),
        0 8px 12px 0 rgba(0, 0, 0, 0.12);
    }
  }
}
</style>
